import BigNumber from 'bignumber.js';

export const getSwapPathDisplay = (paths: string[]) => {
  const displayPath = paths.map((item, index) => {
    // check if item is a number (slippage)
    if (!isNaN(Number(item))) {
      return `${new BigNumber(item).dividedBy(10000).toString()}%`;
    }
    return item;
  });

  return displayPath.join(' -> ');
};
